import styled from 'styled-components';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  isDragging?: boolean;
}

export const ItemContent = styled(Box)<Props>(({ theme, isDragging }) => {
  const defaultStyle = {
    borderRadius: `${theme.radii.medium}px`,
    maxWidth: 'inherit',
    width: '100%',
    border: `1px solid ${theme.colors.neutral[300]}`,
  };

  if (isDragging) {
    return {
      ...defaultStyle,
      background: theme.colors.primary[100],
      border: `1px solid ${theme.colors.primary[300]}`,
      boxShadow: theme.shadows['500'],
    };
  }

  return {
    ...defaultStyle,
    background: theme.colors.white,

    '&:hover': {
      background: theme.colors.neutral[100],
      border: `1px solid ${theme.colors.neutral[300]}`,
    },
  };
});
